module.exports = __webpack_public_path__ + "static/media/virtual-sprite.80c013ba.png";